var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDots = function SvgDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm6.5 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
    fill: "currentColor"
  })));
};

export { SvgDots as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03IDEyQzcgMTIuODI4NCA2LjMyODQzIDEzLjUgNS41IDEzLjVDNC42NzE1NyAxMy41IDQgMTIuODI4NCA0IDEyQzQgMTEuMTcxNiA0LjY3MTU3IDEwLjUgNS41IDEwLjVDNi4zMjg0MyAxMC41IDcgMTEuMTcxNiA3IDEyWk0xMy41IDEyQzEzLjUgMTIuODI4NCAxMi44Mjg0IDEzLjUgMTIgMTMuNUMxMS4xNzE2IDEzLjUgMTAuNSAxMi44Mjg0IDEwLjUgMTJDMTAuNSAxMS4xNzE2IDExLjE3MTYgMTAuNSAxMiAxMC41QzEyLjgyODQgMTAuNSAxMy41IDExLjE3MTYgMTMuNSAxMlpNMTguNSAxMy41QzE5LjMyODQgMTMuNSAyMCAxMi44Mjg0IDIwIDEyQzIwIDExLjE3MTYgMTkuMzI4NCAxMC41IDE4LjUgMTAuNUMxNy42NzE2IDEwLjUgMTcgMTEuMTcxNiAxNyAxMkMxNyAxMi44Mjg0IDE3LjY3MTYgMTMuNSAxOC41IDEzLjVaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";